/*
 *
 * UserHeaderBox reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_USER_WATCHER,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
  UPLOAD_LOGO_WATCHER,
} from "./constants"

export const initialState = fromJS({
  username: "",
  isLoading: false,
  error: false,
})

function userHeaderBoxReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_WATCHER:
    case UPLOAD_LOGO_WATCHER:
      return state.set("isLoading", true)
    case GET_USER_SUCCESS:
      return state.set("isLoading", false).set("username", action.payload)
    case GET_USER_FAILED:
      return state.set("isLoading", false).set("error", true)
    default:
      return state
  }
}

export default userHeaderBoxReducer
